<script setup lang="ts">
import { Bookmark, CalendarDays, ClipboardList, LogOut, Pencil, Star, UserRound } from '../components/wx-icons'
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import StatePanel from '../components/StatePanel.vue'
import { api } from '../services/api'
import { authState, clearAuth } from '../services/auth'

const router = useRouter()
const profile = ref<any>(null)
const loading = ref(true)
const ratingOpen = ref(false)
const ratingValue = ref('3.0')
const ratingSaving = ref(false)
const ratingError = ref('')
const cards = [
  { to: '/me/activities', icon: CalendarDays, title: '我的活动', text: '查看参加和发起的球局' },
  { to: '/me/venues', icon: Bookmark, title: '收藏与到过', text: '快速找到熟悉的场馆' },
  { to: '/me/orders', icon: ClipboardList, title: '我的订场', text: '查看叮球订场订单' },
]

async function load() {
  if (!authState.value) return
  loading.value = true
  profile.value = await api(`/users/${encodeURIComponent(authState.value.user.id)}`).catch(() => null)
  loading.value = false
}
function logout() { clearAuth(); router.replace('/') }
async function saveRating() {
  if (!authState.value || ratingSaving.value) return
  ratingSaving.value = true
  ratingError.value = ''
  try {
    await api(`/users/${encodeURIComponent(authState.value.user.id)}/self-rating`, {
      method: 'POST',
      body: JSON.stringify({ value: Number(ratingValue.value) }),
    })
    ratingOpen.value = false
    await load()
  } catch (reason: any) {
    ratingError.value = reason?.message || '自评保存失败'
  } finally { ratingSaving.value = false }
}
onMounted(load)
</script>

<template>
  <div class="shell me-page">
    <StatePanel v-if="loading" mode="loading" />
    <template v-else>
      <section class="profile-hero">
        <div class="profile-avatar"><img v-if="profile?.avatarUrl" :src="profile.avatarUrl" alt="" /><UserRound v-else :size="42" /></div>
        <div><span class="section-kicker">MY DINGTENNIS</span><h1>{{ profile?.nickname || authState?.user.nickname || '叮球用户' }}</h1><p>{{ profile?.bio || profile?.introduction || '去打球，认识更多有趣的球友。' }}</p></div>
        <RouterLink class="button button-secondary" to="/me/profile"><Pencil :size="17" />编辑资料</RouterLink>
      </section>
      <section class="profile-stats"><div><b>{{ profile?.stats?.createdActivities || 0 }}</b><span>发起活动</span></div><div><b>{{ profile?.stats?.joinedActivities || 0 }}</b><span>参与活动</span></div><div><b>{{ profile?.ntrp ? Number(profile.ntrp).toFixed(1) : '未评' }}</b><span>NTRP</span></div></section>
      <div class="me-grid"><RouterLink v-for="item in cards" :key="item.to" class="me-entry" :to="item.to"><component :is="item.icon" :size="24" /><div><h2>{{ item.title }}</h2><p>{{ item.text }}</p></div></RouterLink><button class="me-entry logout-entry" type="button" @click="logout"><LogOut :size="24" /><div><h2>退出登录</h2><p>清除当前浏览器登录状态</p></div></button></div>
      <section class="content-card ntrp-card"><Star :size="24" /><div><h2>NTRP 参考分</h2><p>当前展示来自后端评级系统，可信度由后端计算。</p></div><strong>{{ profile?.ntrp ? Number(profile.ntrp).toFixed(1) : '未评级' }}</strong><button class="button button-secondary" type="button" @click="ratingOpen = true">{{ profile?.ntrp ? '重新自评' : '开始自评' }}</button></section>
      <div v-if="ratingOpen" class="modal-backdrop" @click.self="ratingOpen = false"><form class="rating-modal" @submit.prevent="saveRating"><span class="section-kicker">SELF RATING</span><h2>选择你的当前水平</h2><p>自评是评级系统的起点，不会伪造比赛结果。重新自评可能受冷却时间限制。</p><label>NTRP 档位<select v-model="ratingValue"><option v-for="n in 10" :key="n" :value="(n / 2).toFixed(1)">{{ (n / 2).toFixed(1) }}</option></select></label><p v-if="ratingError" class="form-error">{{ ratingError }}</p><div class="modal-actions"><button class="button button-secondary" type="button" @click="ratingOpen = false">取消</button><button class="button button-primary" type="submit" :disabled="ratingSaving">{{ ratingSaving ? '保存中' : '确认自评' }}</button></div></form></div>
    </template>
  </div>
</template>
